import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
import Compute from '@/components/Compute'
import Snapshot from '@/components/Snapshot'
import Flavor from '@/components/Flavor'
import Keypair from '@/components/Keypair'
import Image from '@/components/Image'
import Payone from '@/components/Payone'
import NewCompute from '@/components/NewCompute'
import NewKeypair from '@/components/NewKeypair'
import User from '@/components/User'
import Floating from '@/components/Floating'
import Logs from '@/components/Logs'
import Interface from '@/components/Interface'
import Register from '@/components/Register'
import Billing from '@/components/Billing'
import InterimBilling from '@/components/InterimBilling'
import SecurityGroups from '@/components/SecurityGroups'
import SecurityGroupRules from '@/components/SecurityGroupRules'
import Volume from '@/components/Volume'
import RegisterForm from '../components/RegisterForm'
import RegisterConfirm from '../components/RegisterConfirm'
import RegisterPayment from '../components/RegisterPayment'
import RegisterPaymentConfirm from '../components/RegisterPaymentConfirm'
import CrefopayNotification from '../components/CrefopayNotification'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login
    },
    {
      path: '/register',
      component: Register,
      children: [
        {
          path: 'payment',
          name: 'RegisterPayment',
          component: RegisterPayment
        },
        {
          path: 'payment/:orderID/:paymentMethod/:paymentInstrumentID',
          name: 'RegisterPaymentConfirm',
          component: RegisterPaymentConfirm
        },
        {
          path: 'confirm/:id',
          name: 'RegisterConfirm',
          component: RegisterConfirm
        },
        {
          path: '',
          name: 'RegisterForm',
          component: RegisterForm
        }
      ]
    },
    {
      path: '/notification/crefopay/:orderID/:paymentMethod/:paymentInstrumentID',
      name: 'CrefopayNotification',
      component: CrefopayNotification
    },
    {
      path: '/app',
      name: 'App',
      component: Interface,
      children: [
        {
          path: 'computes',
          name: 'Compute',
          component: Compute,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'computes/new',
          name: 'New Compute',
          component: NewCompute,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'snapshots',
          name: 'Snapshot',
          component: Snapshot,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'volumes',
          name: 'Volume',
          component: Volume,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'flavors',
          name: 'Flavor',
          component: Flavor,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'floating',
          name: 'Floating',
          component: Floating,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'keypairs',
          name: 'Keypair',
          component: Keypair,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'keypairs/new',
          name: 'New Keypair',
          component: NewKeypair,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'images',
          name: 'Image',
          component: Image,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'user',
          name: 'User',
          component: User,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'user/:orderID/:paymentMethod/:paymentInstrumentID',
          name: 'UserCrefopay',
          component: User,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'payone',
          name: 'Payone',
          component: Payone,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'logs',
          name: 'Logs',
          component: Logs,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'billing',
          name: 'Billing',
          component: Billing,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'interimBilling',
          name: 'InterimBilling',
          component: InterimBilling,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'firewall',
          name: 'SecurityGroups',
          component: SecurityGroups,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'firewall/:id',
          name: 'SecurityGroupRules',
          component: SecurityGroupRules,
          meta: {
            requiresAuth: true
          }
        }
      ]
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth) {
    if (typeof window.sessionStorage.jwt !== 'undefined' && (window.sessionStorage.expires - Math.floor(Date.now() / 1000)) > 0) {
      next()
    } else {
      next({name: 'Login'})
    }
  }
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js